import state from '@/vuex/documentos-favoritos/state.js'
import getters from '@/vuex/documentos-favoritos/getters.js'
import mutations from '@/vuex/documentos-favoritos/mutations.js'
import actions from '@/vuex/documentos-favoritos/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
